/**
 * Loops around elements of `array` to start with element currently at `index`.
 *
 * @param array - The array to be arranged
 * @param index - The index of element to be shifted to the first position
 */
export const arrange = <T>(array: Array<T>, index: number): Array<T> => [
    ...array.slice(index),
    ...array.slice(0, index),
];
